const FOUNDING_YEAR = 2000;
export const YEARS_IN_BUSINESS = new Date().getFullYear() - FOUNDING_YEAR;
